export default __webpack_public_path__ + "media/icons/pro-badge-small-280c227e.svg";